
if (!customElements.get("ktg-voucher-form")) { 
    class KtgVoucherForm extends HTMLElement { 
        constructor() { 
            super();
            this._init(); 
        }

        _init(){
            this.parentContainer = this.closest('ktg-voucher-form-container');
            this.childNameField = this.querySelector('#ktg-child-name');
            this.childNameErrorField = this.querySelector('#ktg-child-name-error');
            this.voucherNumberField = this.querySelector('#ktg-voucher-number');
            this.voucherNumberErrorField = this.querySelector('#ktg-voucher-number-error');  
            this.index = this.dataset.index;
            this.form = {
                'voucherNumber': '',
                'childName': ''
            }
            this.isValidForm = false; 

            this.addEventListener('change', this._handleChangeEvent.bind(this));
            this.addEventListener('input', this._handleChangeEvent.bind(this));
        }

        _populateForm(index){
            const formData = window.ktg?.forms?.[`${index}`];
            const childName = formData?.childName || '';
            const voucherNumber = formData?.voucherNumber || '';
            this.childNameField.value = childName;
            this.voucherNumberField.value = voucherNumber;
            this.dispatchEvent(new CustomEvent('change'));
        }

        async _handleChangeEvent(evt){
            const field = evt.target;
            const inputValue = field.value || '';
            field.value = field.dataset.fieldType == 'number' ? inputValue.replace(/[^a-zA-Z0-9]/g, '') : inputValue.replace(/[^a-zA-Z\s]/g, '');

            this._validateField(this.childNameField, this.childNameField.dataset.fieldType);
            this._validateField(this.voucherNumberField, this.voucherNumberField.dataset.fieldType);
            this.isValidForm = await this._validateForm();
            if(this.isValidForm){
                this.setAttribute('data-valid-form', true);
                this._updateLocalStorageData();
            } else this.setAttribute('data-valid-form', false);
            this.parentContainer._validateVoucherForms();
            document.dispatchEvent(new CustomEvent('ktg:voucher-values-changed'));
            evt.stopPropagation();
        }

        async _validateForm(){
            const isValidForm = this.childNameField.dataset.status == 'true' && this.voucherNumberField.dataset.status == 'true' ? true : false;
            return isValidForm; 
        }

        _validateField(field, type){
            const value = field.value.trim();
            const nameRegex = /^[a-zA-Z\s]{3,50}$/;
            const voucherNumberRegex = /^[a-zA-Z0-9]{10}$/;

            const validationRules = {
                'name': {
                    regex: nameRegex,
                    emptyMessage: window.ktg.errorMessage.emptyChildName,
                    invalidMessage: window.ktg.errorMessage.invalidChildName
                },
                'number': {
                    regex: voucherNumberRegex,
                    emptyMessage: window.ktg.errorMessage.emptyVoucherNumber,
                    invalidMessage: window.ktg.errorMessage.invalidVoucherNumber,
                    usedMessage: window.ktg.errorMessage.usedVoucherNumber
                }
            };

            const { regex, emptyMessage, invalidMessage } = validationRules[type];
            if(type == 'number') this.form.voucherNumber = value.toUpperCase();
            else this.form.childName = this._capitalizeEachWord(value);

            if (value === '') {
                this._setError(field, emptyMessage, false);
            } else if (!regex.test(value)) {
                this._setError(field, invalidMessage, false);
            } 
            else if(type == 'number' && window.ktg.cartVoucherNumbersData.includes(this.form.voucherNumber)){
                this._setError(field, validationRules.number.usedMessage, false);
            } else {
                this._setError(field, '', true);
            }
        }

        _setError(field, message, isValid) {
            const errorField = field.dataset.fieldType === 'name' ? this.childNameErrorField : this.voucherNumberErrorField;
            errorField.innerHTML = message ? window.ktg.errorMessage.errorIcon + message : '';
            field.dataset.status = isValid;
        }

        _capitalize(str) {
            if (!str) return str;
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }

        _capitalizeEachWord(str) {
            const thi$1 = this;
            if (!str) return str;
            return str.split(' ').map(word => thi$1._capitalize(word)).join(' ');
        }

        _updateLocalStorageData(){
            window.ktg.savedData.forms[this.index] = window.ktg.savedData.forms[this.index] || {}
            window.ktg.savedData.products[`${window.ktg.productData.id}`] = window.ktg.productSavedData;
            window.ktg.forms[this.index] = window.ktg.forms[this.index] || { 'voucherNumber': '', 'childName': ''};
            window.ktg.forms[this.index].voucherNumber = this.form.voucherNumber;
            window.ktg.forms[this.index].childName = this.form.childName;
            window.ktg.savedData.forms[this.index] = window.ktg.forms[this.index];
            document.dispatchEvent(new CustomEvent('ktg:voucher_updated', { detail: window.ktg.savedData}));
        }
    }
    customElements.define("ktg-voucher-form", KtgVoucherForm)
}

if (!customElements.get("ktg-voucher-form-container")) { 
    class KtgVoucherFormContainer extends HTMLElement { 
        constructor() { 
            super();
            this._init(); 
        }

        _init(){
            document.addEventListener('ktg:voucher_updated', this._setLocalStorageData.bind(this));
            this.isValidSession = false; 
            this.localStorageKey = 'ktgData';
            this.savedKtgData = this._fetchLocalStorageData();
            this.cartForm = document.querySelector('.ktg-cart-form');
            this.qtySelector = document.querySelector('#main-product #quantity');
            this.voucherHeader = this.querySelector('#ktg-voucher-form-header-container');
            this.voucherBody = this.querySelector('#ktg-voucher-form-body-container');
            this.productSavedData = this.savedKtgData?.products?.[`${window.ktg.productData.id}`] || {};
            this.savedQty = this.productSavedData?.qty || 1;
            this.voucherFormsNumber = this.qtySelector ? this.savedQty : 1;
            this.formData = this.savedKtgData?.forms || {}; 
            window.ktg.savedData = this.savedKtgData;
            window.ktg.productSavedData = {
                'qty': this.voucherFormsNumber
            }
            window.ktg.forms = this.formData;
            this._updateVoucherForms(this.voucherFormsNumber);
            document.addEventListener('ktg:product-ui-refresh', this._addEventListeners.bind(this));
            document.addEventListener('ktg:voucher-values-changed', this._validateVoucherForms.bind(this));
            document.addEventListener('ktg:product-added-to-cart', this._addProductToCart.bind(this));
            document.addEventListener('ktg:product-not-added-to-cart', this._productNotAddedToCart.bind(this));

            document.dispatchEvent(new CustomEvent('ktg:product-ui-refresh'));
            this._activateMutationObserver();
        }

        _activateMutationObserver(){
            const thi$1 = this;
            const KtgObserver = new MutationObserver((mutationsList, KtgObserver) => {
                var isEventAdded = false;
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                       if(mutation.target.classList.contains('ktg-cart-form')){
                            const dummyButton = document.querySelector('#ktg-custom-add-to-cart-button');
                            if(dummyButton && !isEventAdded){
                                dummyButton.addEventListener('click', thi$1._dummyAddToCartEvent.bind(thi$1))
                                isEventAdded = true;
                            }
                       }
                    }
                });
            });
            KtgObserver.observe(document.getElementById('main-product'), { childList: true, subtree: true });
        }

        _addEventListeners(evt){
            this.dummyButton = document.getElementById('ktg-custom-add-to-cart-button');
            this.submitBtn = document.getElementById('ktg-original-add-to-cart-button');
            document.dispatchEvent(new CustomEvent('ktg:voucher-values-changed'));
            this.qtySelector && this.qtySelector.addEventListener('change', this._qtyChangeEvent.bind(this));
            this.dummyButton.addEventListener('click', this._dummyAddToCartEvent.bind(this));
        }

        _dummyAddToCartEvent(evt) {
            const submitBtn = document.getElementById('ktg-original-add-to-cart-button');
            const dummyButton = document.getElementById('ktg-custom-add-to-cart-button');
            evt.stopPropagation();
            submitBtn.classList.remove('ktg-hide');
            dummyButton.classList.add('ktg-hide');
            submitBtn.click();
        }

        _productNotAddedToCart(){
            const submitBtn = document.getElementById('ktg-original-add-to-cart-button');
            const dummyButton = document.getElementById('ktg-custom-add-to-cart-button');
            submitBtn.classList.add('ktg-hide');
            dummyButton.classList.remove('ktg-hide');
        }

        _addProductToCart(){
            this._deleteLocalStorageData();
            const voucherForms = this.querySelectorAll('ktg-voucher-form');
            voucherForms.forEach(form => {
                form.querySelectorAll('input').forEach(input => {
                    input.value = '';
                })
            })
            window.location.href = '/';
        }

        _validateVoucherForms(){
            this.dummyButton = document.querySelector('#ktg-custom-add-to-cart-button');
            this.submitBtn = document.querySelector('#ktg-original-add-to-cart-button');
            let inValidSessions = this.querySelectorAll('ktg-voucher-form[data-valid-form="false"]');
            if(!inValidSessions.length){
                this.dummyButton.removeAttribute('disabled');
                this._prepareCartFormData();
            } else this.dummyButton.setAttribute('disabled', true);
        }

        _prepareCartFormData(){
            const cartForm = document.querySelector('#main-product .ktg-cart-form');
            const cartVoucherFields = cartForm.querySelectorAll('.ktg-voucher-fields');
            
            // Remove all voucher fields
            cartVoucherFields.forEach(field => field.remove());
            const voucherForms = this.querySelectorAll('ktg-voucher-form');
            const totalForms = voucherForms.length;

            voucherForms.forEach(form => {
                let formIndex = '';
                if (totalForms > 1) {
                    formIndex = ` - form.index`;
                }
            
                cartForm.innerHTML += `<input type="hidden" class="ktg-voucher-fields" value="${form.form.childName}" name="properties[Child Name${formIndex}]"/>`;
                cartForm.innerHTML += `<input type="hidden" class="ktg-voucher-fields" value="${form.form.voucherNumber}" name="properties[Voucher Number${formIndex}]"/>`;
            });
        }

        _fetchLocalStorageData(){
            if(localStorage.getItem(this.localStorageKey)){
                return JSON.parse(localStorage.getItem('ktgData'));
            }else {
                const data = { 'products': {}, 'forms': {}}; 
                document.dispatchEvent(new CustomEvent('ktg:voucher_updated', { detail: data }))
                return data;
            }
        }

        _setLocalStorageData(evt){
            const data = evt.detail;
            localStorage.setItem(this.localStorageKey, JSON.stringify(data));
        }

        _deleteLocalStorageData(){
            localStorage.removeItem(this.localStorageKey);
        }

        _qtyChangeEvent(evt){
            const qty = +evt.currentTarget.value;
            if(qty < 1) return; 
            this.voucherFormsNumber = qty;
            this._updateVoucherForms(qty);
        }

        _updateVoucherForms(qty){
            for(let index = 1; index <= qty; index++){
                const formHTML = window.ktg.voucherFormHtml;
                const parsedHTML = new DOMParser().parseFromString(formHTML, 'text/html');
                const form = parsedHTML.querySelector('ktg-voucher-form');
                form.dataset.validForm = 'false';
                form.id = `form--${index}`;
                form.dataset.index = index;
                form.classList.remove('ktg-hide');
                this.voucherBody.appendChild(parsedHTML.body.firstChild);
                const voucherForm = this.voucherBody.querySelector(`ktg-voucher-form#form--${index}`);
                voucherForm._populateForm(index);
            }
        }
    }
    customElements.define("ktg-voucher-form-container",KtgVoucherFormContainer)
}